<template>
  <form-section :title="$t('Integrations_Settings_BasicSettings')">
    <rest-form-item
      :label="$t('Integrations_Field_Name')"
      :hint="$t('Integrations_Field_Name_Description')"
      prop="name"
    >
      <el-input
        v-model="model.name"
        :placeholder="$t('Integrations_Field_Name')"
      />
    </rest-form-item>

    <rest-form-item
      :label="$t('Integrations_SportsFeedStream_Field_Sport')"
      :hint="$t('Integrations_SportsFeedStream_Field_Sport_Description')"
      prop="params.sport"
    >
      <enum-select
        v-model="model.params.sport"
        :placeholder="$t('Integrations_SportsFeedStream_Field_Sport')"
        :options="SportsLabel"
        :disabled="!!model.id"
        data-qa="sports-feed-stream-sport"
      />
    </rest-form-item>

    <rest-form-item
      :label="$t('Integrations_SportsFeedStream_Field_Identifier')"
      :hint="$t('Integrations_SportsFeedStream_Field_Identifier_Description')"
      prop="params.identifier"
    >
      <enum-select
        v-model="model.params.identifier"
        :placeholder="$t('Integrations_SportsFeedStream_Field_Identifier')"
        :options="identifierList"
        :disabled="!!model.id"
        data-qa="sports-feed-stream-identifier"
      />
    </rest-form-item>
  </form-section>
</template>

<script>
import EnumSelect from '@/common/components/form/EnumSelect'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { listIdentifierLabel } from '@/modules/lists/enum/ListRecordEnums'
import { SportsLabel } from '@/modules/integrations/types/sportsfeedstream/enum/SportsLabelEnum'
import { validateIdentifier } from '@/modules/lists/utils'
import _ from 'lodash'

export default {
  name: 'SportsFeedStreamSettings',

  components: {
    FormSection,
    RestFormItem,
    EnumSelect
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          sport: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          identifier: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      },
      listIdentifierLabel,
      SportsLabel
    }
  },

  computed: {
    features() {
      return this.$store.state.app.features || {}
    },

    identifierList() {
      const allowed = Object.keys(this.listIdentifierLabel).filter(key =>
        validateIdentifier(key, this.features)
      )

      return _.pick(this.listIdentifierLabel, allowed)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/sportsfeedstream/SportsFeedStreamSettings.vue